export const connectedTranslations: Record<string, any> = {
  en: {
  "lockedNotice": "Shared match facts are locked after both players connect. Your private notes, ratings and personal data remain editable.",
  "badge": "Connected Match",
  "status": {
    "title": "CONNECTED",
    "body": "This match is connected with {{name}}. Shared facts are locked; your private notes and ratings remain yours."
  },
  "sender": {
    "waiting": "Invitation pending",
    "waitingDetail": "Still waiting for {{name}}. The link can be claimed once and expires {{date}}.",
    "replace": "Replace link",
    "title": "CONNECT THIS MATCH",
    "body": "Send the match to your opponent. They will see only the shared match facts, confirm from their own account, and get their own private copy.",
    "send": "Send to opponent",
    "creating": "Creating secure link…",
    "ready": "Invitation ready",
    "readyDetail": "This link can be claimed once and expires {{date}}.",
    "share": "Share",
    "copy": "Copy link",
    "copied": "Copied",
    "newLink": "New link",
    "revoke": "Revoke",
    "revokedTitle": "Invitation revoked",
    "revokedDetail": "The old link no longer works. You can create a fresh invitation for this same match — no need to log it again.",
    "reissue": "Create a new invitation",
    "pilotNote": "Pilot: singles only. Ratings, notes, readiness and watch/health data are never included in the invitation.",
    "copiedToast": "Invitation link copied.",
    "revokedToast": "Invitation revoked.",
    "errorCreate": "Could not create invitation.",
    "errorRevoke": "Could not revoke invitation.",
    "errorShare": "Could not share the invitation link.",
    "errorCopy": "Could not copy the invitation link."
  },
  "recipient": {
    "title": "CONFIRM YOUR MATCH",
    "subtitle": "One physical match, two private player perspectives.",
    "loading": "Loading secure invitation…",
    "unavailableTitle": "Invitation unavailable",
    "missingToken": "This invitation link is missing or invalid.",
    "unavailable": "This invitation is invalid or no longer available.",
    "invitedBy": "Invited by",
    "date": "Date",
    "court": "Court",
    "surface": "Surface",
    "type": "Type",
    "scoreTitle": "Score from your perspective",
    "privacyTitle": "Your private data stays private",
    "privacyBody": "You receive only the shared match facts. Your ratings, notes, readiness and watch/health data belong only to you.",
    "signInTitle": "Sign in to confirm",
    "signInBody": "The invitation is saved in this browser while you sign in or create your account.",
    "signIn": "Sign in",
    "createAccount": "Create account",
    "nameTitle": "How should your name appear?",
    "nameBody": "Your canonical Tennis Log name is yours to choose. The sender cannot overwrite it.",
    "keepName": "Keep my current name",
    "useTheirName": "Use the name they entered",
    "differentName": "Choose a different name",
    "namePlaceholder": "Your Tennis Log display name",
    "confirm": "Confirm & add to my Tennis Log",
    "confirming": "Connecting match…",
    "confirmNote": "Confirming links this local opponent identity to your account. It does not auto-share any future match.",
    "claimError": "Could not connect this match.",
    "successTitle": "MATCH CONNECTED",
    "successBody": "The match has been added to your private Tennis Log from your own perspective.",
    "openMatch": "Open my match",
    "viewMatches": "View matches"
  }
},
  el: {
  "lockedNotice": "Τα κοινά στοιχεία του αγώνα κλειδώνουν όταν συνδεθούν και οι δύο παίκτες. Οι προσωπικές σας σημειώσεις, βαθμολογίες και προσωπικά δεδομένα παραμένουν επεξεργάσιμα.",
  "badge": "Connected Match",
  "status": {
    "title": "ΣΥΝΔΕΔΕΜΕΝΟ",
    "body": "Αυτός ο αγώνας είναι συνδεδεμένος με τον/την {{name}}. Τα κοινά στοιχεία είναι κλειδωμένα· οι προσωπικές σας σημειώσεις και βαθμολογίες παραμένουν δικές σας."
  },
  "sender": {
    "waiting": "Εκκρεμεί πρόσκληση",
    "waitingDetail": "Αναμένεται ο/η {{name}}. Ο σύνδεσμος μπορεί να χρησιμοποιηθεί μία φορά και λήγει {{date}}.",
    "replace": "Αντικατάσταση συνδέσμου",
    "title": "ΣΥΝΔΕΣΕ ΑΥΤΟΝ ΤΟΝ ΑΓΩΝΑ",
    "body": "Στείλε τον αγώνα στον αντίπαλό σου. Θα δει μόνο τα κοινά στοιχεία του αγώνα, θα τον επιβεβαιώσει από τον δικό του λογαριασμό και θα έχει το δικό του ιδιωτικό αντίγραφο.",
    "send": "Αποστολή στον αντίπαλο",
    "creating": "Δημιουργία ασφαλούς συνδέσμου…",
    "ready": "Η πρόσκληση είναι έτοιμη",
    "readyDetail": "Ο σύνδεσμος μπορεί να χρησιμοποιηθεί μία φορά και λήγει στις {{date}}.",
    "share": "Κοινοποίηση",
    "copy": "Αντιγραφή συνδέσμου",
    "copied": "Αντιγράφηκε",
    "newLink": "Νέος σύνδεσμος",
    "revoke": "Ανάκληση",
    "revokedTitle": "Η πρόσκληση ανακλήθηκε",
    "revokedDetail": "Ο παλιός σύνδεσμος δεν λειτουργεί πλέον. Μπορείς να δημιουργήσεις νέα πρόσκληση για τον ίδιο αγώνα — δεν χρειάζεται να τον καταχωρίσεις ξανά.",
    "reissue": "Δημιουργία νέας πρόσκλησης",
    "pilotNote": "Πιλοτικά: μόνο singles. Βαθμολογίες, σημειώσεις, ετοιμότητα και δεδομένα smartwatch/υγείας δεν περιλαμβάνονται ποτέ στην πρόσκληση.",
    "copiedToast": "Ο σύνδεσμος πρόσκλησης αντιγράφηκε.",
    "revokedToast": "Η πρόσκληση ανακλήθηκε.",
    "errorCreate": "Δεν ήταν δυνατή η δημιουργία πρόσκλησης.",
    "errorRevoke": "Δεν ήταν δυνατή η ανάκληση της πρόσκλησης.",
    "errorShare": "Δεν ήταν δυνατή η κοινοποίηση του συνδέσμου.",
    "errorCopy": "Δεν ήταν δυνατή η αντιγραφή του συνδέσμου."
  },
  "recipient": {
    "title": "ΕΠΙΒΕΒΑΙΩΣΕ ΤΟΝ ΑΓΩΝΑ ΣΟΥ",
    "subtitle": "Ένας αγώνας, δύο ιδιωτικές οπτικές των παικτών.",
    "loading": "Φόρτωση ασφαλούς πρόσκλησης…",
    "unavailableTitle": "Η πρόσκληση δεν είναι διαθέσιμη",
    "missingToken": "Ο σύνδεσμος πρόσκλησης λείπει ή δεν είναι έγκυρος.",
    "unavailable": "Η πρόσκληση δεν είναι έγκυρη ή δεν είναι πλέον διαθέσιμη.",
    "invitedBy": "Πρόσκληση από",
    "date": "Ημερομηνία",
    "court": "Γήπεδο",
    "surface": "Επιφάνεια",
    "type": "Τύπος",
    "scoreTitle": "Σκορ από τη δική σου οπτική",
    "privacyTitle": "Τα ιδιωτικά σου δεδομένα παραμένουν ιδιωτικά",
    "privacyBody": "Λαμβάνεις μόνο τα κοινά στοιχεία του αγώνα. Οι βαθμολογίες, οι σημειώσεις, η ετοιμότητα και τα δεδομένα smartwatch/υγείας ανήκουν μόνο σε εσένα.",
    "signInTitle": "Σύνδεση για επιβεβαίωση",
    "signInBody": "Η πρόσκληση αποθηκεύεται σε αυτό το πρόγραμμα περιήγησης όσο συνδέεσαι ή δημιουργείς λογαριασμό.",
    "signIn": "Σύνδεση",
    "createAccount": "Δημιουργία λογαριασμού",
    "nameTitle": "Πώς θέλεις να εμφανίζεται το όνομά σου;",
    "nameBody": "Το όνομά σου στο Tennis Log το επιλέγεις εσύ. Ο αποστολέας δεν μπορεί να το αλλάξει.",
    "keepName": "Διατήρηση του τρέχοντος ονόματος",
    "useTheirName": "Χρήση του ονόματος που καταχώρισε",
    "differentName": "Επιλογή άλλου ονόματος",
    "namePlaceholder": "Το εμφανιζόμενο όνομά σου στο Tennis Log",
    "confirm": "Επιβεβαίωση & προσθήκη στο Tennis Log μου",
    "confirming": "Σύνδεση αγώνα…",
    "confirmNote": "Η επιβεβαίωση συνδέει αυτή την τοπική ταυτότητα αντιπάλου με τον λογαριασμό σου. Δεν κοινοποιεί αυτόματα μελλοντικούς αγώνες.",
    "claimError": "Δεν ήταν δυνατή η σύνδεση αυτού του αγώνα.",
    "successTitle": "Ο ΑΓΩΝΑΣ ΣΥΝΔΕΘΗΚΕ",
    "successBody": "Ο αγώνας προστέθηκε στο ιδιωτικό σου Tennis Log από τη δική σου οπτική.",
    "openMatch": "Άνοιγμα του αγώνα μου",
    "viewMatches": "Προβολή αγώνων"
  }
},
  es: {
  "lockedNotice": "Los datos compartidos del partido se bloquean cuando ambos jugadores se conectan. Tus notas, valoraciones y datos personales privados siguen siendo editables.",
  "badge": "Connected Match",
  "status": {
    "title": "CONECTADO",
    "body": "Este partido está conectado con {{name}}. Los datos compartidos están bloqueados; tus notas y valoraciones privadas siguen siendo tuyas."
  },
  "sender": {
    "waiting": "Invitación pendiente",
    "waitingDetail": "Aún esperando a {{name}}. El enlace puede usarse una vez y caduca el {{date}}.",
    "replace": "Reemplazar enlace",
    "title": "CONECTA ESTE PARTIDO",
    "body": "Envía el partido a tu rival. Solo verá los datos compartidos del partido, lo confirmará desde su propia cuenta y tendrá su copia privada.",
    "send": "Enviar al rival",
    "creating": "Creando enlace seguro…",
    "ready": "Invitación lista",
    "readyDetail": "El enlace se puede usar una vez y caduca el {{date}}.",
    "share": "Compartir",
    "copy": "Copiar enlace",
    "copied": "Copiado",
    "newLink": "Nuevo enlace",
    "revoke": "Revocar",
    "revokedTitle": "Invitación revocada",
    "revokedDetail": "El enlace anterior ya no funciona. Puedes crear una invitación nueva para el mismo partido, sin volver a registrarlo.",
    "reissue": "Crear una nueva invitación",
    "pilotNote": "Piloto: solo singles. Las valoraciones, notas, estado de forma y datos de smartwatch/salud nunca se incluyen en la invitación.",
    "copiedToast": "Enlace de invitación copiado.",
    "revokedToast": "Invitación revocada.",
    "errorCreate": "No se pudo crear la invitación.",
    "errorRevoke": "No se pudo revocar la invitación.",
    "errorShare": "No se pudo compartir el enlace de invitación.",
    "errorCopy": "No se pudo copiar el enlace de invitación."
  },
  "recipient": {
    "title": "CONFIRMA TU PARTIDO",
    "subtitle": "Un mismo partido, dos perspectivas privadas.",
    "loading": "Cargando invitación segura…",
    "unavailableTitle": "Invitación no disponible",
    "missingToken": "Falta el enlace de invitación o no es válido.",
    "unavailable": "Esta invitación no es válida o ya no está disponible.",
    "invitedBy": "Invitación de",
    "date": "Fecha",
    "court": "Pista",
    "surface": "Superficie",
    "type": "Tipo",
    "scoreTitle": "Resultado desde tu perspectiva",
    "privacyTitle": "Tus datos privados siguen siendo privados",
    "privacyBody": "Solo recibes los datos compartidos del partido. Tus valoraciones, notas, estado de forma y datos de smartwatch/salud son solo tuyos.",
    "signInTitle": "Inicia sesión para confirmar",
    "signInBody": "La invitación se guarda en este navegador mientras inicias sesión o creas tu cuenta.",
    "signIn": "Iniciar sesión",
    "createAccount": "Crear cuenta",
    "nameTitle": "¿Cómo quieres que aparezca tu nombre?",
    "nameBody": "Tu nombre en Tennis Log lo eliges tú. Quien te invita no puede cambiarlo.",
    "keepName": "Mantener mi nombre actual",
    "useTheirName": "Usar el nombre que escribió",
    "differentName": "Elegir otro nombre",
    "namePlaceholder": "Tu nombre visible en Tennis Log",
    "confirm": "Confirmar y añadir a mi Tennis Log",
    "confirming": "Conectando el partido…",
    "confirmNote": "Al confirmar, vinculas esta identidad local de rival con tu cuenta. No comparte automáticamente ningún partido futuro.",
    "claimError": "No se pudo conectar este partido.",
    "successTitle": "PARTIDO CONECTADO",
    "successBody": "El partido se ha añadido a tu Tennis Log privado desde tu propia perspectiva.",
    "openMatch": "Abrir mi partido",
    "viewMatches": "Ver partidos"
  }
},
  fr: {
  "lockedNotice": "Les faits partagés du match sont verrouillés dès que les deux joueurs sont connectés. Vos notes, évaluations et données personnelles privées restent modifiables.",
  "badge": "Connected Match",
  "status": {
    "title": "CONNECTÉ",
    "body": "Ce match est connecté avec {{name}}. Les données partagées sont verrouillées ; vos notes et évaluations privées restent à vous."
  },
  "sender": {
    "waiting": "Invitation en attente",
    "waitingDetail": "En attente de {{name}}. Le lien peut être utilisé une seule fois et expire le {{date}}.",
    "replace": "Remplacer le lien",
    "title": "CONNECTER CE MATCH",
    "body": "Envoyez le match à votre adversaire. Il ne verra que les faits partagés du match, le confirmera depuis son propre compte et obtiendra sa copie privée.",
    "send": "Envoyer à l’adversaire",
    "creating": "Création du lien sécurisé…",
    "ready": "Invitation prête",
    "readyDetail": "Ce lien est utilisable une seule fois et expire le {{date}}.",
    "share": "Partager",
    "copy": "Copier le lien",
    "copied": "Copié",
    "newLink": "Nouveau lien",
    "revoke": "Révoquer",
    "revokedTitle": "Invitation révoquée",
    "revokedDetail": "L’ancien lien ne fonctionne plus. Vous pouvez créer une nouvelle invitation pour ce même match, sans le saisir à nouveau.",
    "reissue": "Créer une nouvelle invitation",
    "pilotNote": "Pilote : simples uniquement. Les notes, évaluations, état de forme et données montre/santé ne sont jamais inclus dans l’invitation.",
    "copiedToast": "Lien d’invitation copié.",
    "revokedToast": "Invitation révoquée.",
    "errorCreate": "Impossible de créer l’invitation.",
    "errorRevoke": "Impossible de révoquer l’invitation.",
    "errorShare": "Impossible de partager le lien d’invitation.",
    "errorCopy": "Impossible de copier le lien d’invitation."
  },
  "recipient": {
    "title": "CONFIRMEZ VOTRE MATCH",
    "subtitle": "Un seul match, deux perspectives privées.",
    "loading": "Chargement de l’invitation sécurisée…",
    "unavailableTitle": "Invitation indisponible",
    "missingToken": "Le lien d’invitation est manquant ou invalide.",
    "unavailable": "Cette invitation est invalide ou n’est plus disponible.",
    "invitedBy": "Invitation de",
    "date": "Date",
    "court": "Court",
    "surface": "Surface",
    "type": "Type",
    "scoreTitle": "Score de votre point de vue",
    "privacyTitle": "Vos données privées restent privées",
    "privacyBody": "Vous recevez uniquement les faits partagés du match. Vos évaluations, notes, état de forme et données montre/santé n’appartiennent qu’à vous.",
    "signInTitle": "Connectez-vous pour confirmer",
    "signInBody": "L’invitation est conservée dans ce navigateur pendant que vous vous connectez ou créez votre compte.",
    "signIn": "Se connecter",
    "createAccount": "Créer un compte",
    "nameTitle": "Comment votre nom doit-il apparaître ?",
    "nameBody": "Votre nom Tennis Log vous appartient. L’expéditeur ne peut pas le modifier.",
    "keepName": "Garder mon nom actuel",
    "useTheirName": "Utiliser le nom qu’il a saisi",
    "differentName": "Choisir un autre nom",
    "namePlaceholder": "Votre nom affiché dans Tennis Log",
    "confirm": "Confirmer et ajouter à mon Tennis Log",
    "confirming": "Connexion du match…",
    "confirmNote": "La confirmation relie cette identité d’adversaire locale à votre compte. Elle ne partage aucun match futur automatiquement.",
    "claimError": "Impossible de connecter ce match.",
    "successTitle": "MATCH CONNECTÉ",
    "successBody": "Le match a été ajouté à votre Tennis Log privé, de votre propre point de vue.",
    "openMatch": "Ouvrir mon match",
    "viewMatches": "Voir les matchs"
  }
},
  de: {
  "lockedNotice": "Die gemeinsamen Match-Fakten sind gesperrt, sobald beide Spieler verbunden sind. Deine privaten Notizen, Bewertungen und persönlichen Daten bleiben bearbeitbar.",
  "badge": "Connected Match",
  "status": {
    "title": "VERBUNDEN",
    "body": "Dieses Match ist mit {{name}} verbunden. Geteilte Fakten sind gesperrt; deine privaten Notizen und Bewertungen bleiben deine."
  },
  "sender": {
    "waiting": "Einladung ausstehend",
    "waitingDetail": "Warten auf {{name}}. Der Link kann einmal verwendet werden und läuft am {{date}} ab.",
    "replace": "Link ersetzen",
    "title": "DIESES MATCH VERBINDEN",
    "body": "Schicke das Match an deinen Gegner. Er sieht nur die gemeinsamen Match-Fakten, bestätigt aus seinem eigenen Konto und erhält seine eigene private Kopie.",
    "send": "An Gegner senden",
    "creating": "Sicherer Link wird erstellt…",
    "ready": "Einladung bereit",
    "readyDetail": "Dieser Link kann einmal genutzt werden und läuft am {{date}} ab.",
    "share": "Teilen",
    "copy": "Link kopieren",
    "copied": "Kopiert",
    "newLink": "Neuer Link",
    "revoke": "Widerrufen",
    "revokedTitle": "Einladung widerrufen",
    "revokedDetail": "Der alte Link funktioniert nicht mehr. Du kannst für dasselbe Match eine neue Einladung erstellen — ohne es erneut zu erfassen.",
    "reissue": "Neue Einladung erstellen",
    "pilotNote": "Pilot: nur Einzel. Bewertungen, Notizen, Readiness und Watch-/Gesundheitsdaten sind niemals Teil der Einladung.",
    "copiedToast": "Einladungslink kopiert.",
    "revokedToast": "Einladung widerrufen.",
    "errorCreate": "Einladung konnte nicht erstellt werden.",
    "errorRevoke": "Einladung konnte nicht widerrufen werden.",
    "errorShare": "Einladungslink konnte nicht geteilt werden.",
    "errorCopy": "Einladungslink konnte nicht kopiert werden."
  },
  "recipient": {
    "title": "BESTÄTIGE DEIN MATCH",
    "subtitle": "Ein Match, zwei private Spielerperspektiven.",
    "loading": "Sichere Einladung wird geladen…",
    "unavailableTitle": "Einladung nicht verfügbar",
    "missingToken": "Der Einladungslink fehlt oder ist ungültig.",
    "unavailable": "Diese Einladung ist ungültig oder nicht mehr verfügbar.",
    "invitedBy": "Eingeladen von",
    "date": "Datum",
    "court": "Platz",
    "surface": "Belag",
    "type": "Art",
    "scoreTitle": "Ergebnis aus deiner Perspektive",
    "privacyTitle": "Deine privaten Daten bleiben privat",
    "privacyBody": "Du erhältst nur die gemeinsamen Match-Fakten. Deine Bewertungen, Notizen, Readiness und Watch-/Gesundheitsdaten gehören allein dir.",
    "signInTitle": "Zum Bestätigen anmelden",
    "signInBody": "Die Einladung bleibt in diesem Browser gespeichert, während du dich anmeldest oder ein Konto erstellst.",
    "signIn": "Anmelden",
    "createAccount": "Konto erstellen",
    "nameTitle": "Wie soll dein Name erscheinen?",
    "nameBody": "Dein Tennis-Log-Name gehört dir. Der Absender kann ihn nicht überschreiben.",
    "keepName": "Aktuellen Namen behalten",
    "useTheirName": "Den eingegebenen Namen verwenden",
    "differentName": "Anderen Namen wählen",
    "namePlaceholder": "Dein Anzeigename in Tennis Log",
    "confirm": "Bestätigen & zu meinem Tennis Log hinzufügen",
    "confirming": "Match wird verbunden…",
    "confirmNote": "Mit dem Bestätigen wird diese lokale Gegner-Identität mit deinem Konto verknüpft. Zukünftige Matches werden nicht automatisch geteilt.",
    "claimError": "Dieses Match konnte nicht verbunden werden.",
    "successTitle": "MATCH VERBUNDEN",
    "successBody": "Das Match wurde deinem privaten Tennis Log aus deiner Perspektive hinzugefügt.",
    "openMatch": "Mein Match öffnen",
    "viewMatches": "Matches ansehen"
  }
},
  it: {
  "lockedNotice": "I dati condivisi del match vengono bloccati quando entrambi i giocatori sono collegati. Le tue note, valutazioni e dati personali privati restano modificabili.",
  "badge": "Connected Match",
  "status": {
    "title": "COLLEGATO",
    "body": "Questa partita è collegata con {{name}}. I dati condivisi sono bloccati; le tue note e valutazioni private restano tue."
  },
  "sender": {
    "waiting": "Invito in attesa",
    "waitingDetail": "In attesa di {{name}}. Il link può essere usato una sola volta e scade il {{date}}.",
    "replace": "Sostituisci link",
    "title": "COLLEGA QUESTA PARTITA",
    "body": "Invia la partita al tuo avversario. Vedrà solo i dati condivisi della partita, la confermerà dal suo account e avrà la sua copia privata.",
    "send": "Invia all’avversario",
    "creating": "Creazione del link sicuro…",
    "ready": "Invito pronto",
    "readyDetail": "Il link può essere usato una sola volta e scade il {{date}}.",
    "share": "Condividi",
    "copy": "Copia link",
    "copied": "Copiato",
    "newLink": "Nuovo link",
    "revoke": "Revoca",
    "revokedTitle": "Invito revocato",
    "revokedDetail": "Il link precedente non funziona più. Puoi creare un nuovo invito per la stessa partita, senza registrarla di nuovo.",
    "reissue": "Crea un nuovo invito",
    "pilotNote": "Pilota: solo singolare. Valutazioni, note, readiness e dati smartwatch/salute non sono mai inclusi nell’invito.",
    "copiedToast": "Link dell’invito copiato.",
    "revokedToast": "Invito revocato.",
    "errorCreate": "Impossibile creare l’invito.",
    "errorRevoke": "Impossibile revocare l’invito.",
    "errorShare": "Impossibile condividere il link dell’invito.",
    "errorCopy": "Impossibile copiare il link dell’invito."
  },
  "recipient": {
    "title": "CONFERMA LA TUA PARTITA",
    "subtitle": "Una partita, due prospettive private.",
    "loading": "Caricamento dell’invito sicuro…",
    "unavailableTitle": "Invito non disponibile",
    "missingToken": "Il link dell’invito è assente o non valido.",
    "unavailable": "Questo invito non è valido o non è più disponibile.",
    "invitedBy": "Invito da",
    "date": "Data",
    "court": "Campo",
    "surface": "Superficie",
    "type": "Tipo",
    "scoreTitle": "Punteggio dalla tua prospettiva",
    "privacyTitle": "I tuoi dati privati restano privati",
    "privacyBody": "Ricevi solo i dati condivisi della partita. Valutazioni, note, readiness e dati smartwatch/salute appartengono solo a te.",
    "signInTitle": "Accedi per confermare",
    "signInBody": "L’invito resta salvato in questo browser mentre accedi o crei il tuo account.",
    "signIn": "Accedi",
    "createAccount": "Crea account",
    "nameTitle": "Come deve apparire il tuo nome?",
    "nameBody": "Il tuo nome su Tennis Log lo scegli tu. Chi ti invita non può modificarlo.",
    "keepName": "Mantieni il nome attuale",
    "useTheirName": "Usa il nome che ha inserito",
    "differentName": "Scegli un altro nome",
    "namePlaceholder": "Il tuo nome visualizzato su Tennis Log",
    "confirm": "Conferma e aggiungi al mio Tennis Log",
    "confirming": "Collegamento della partita…",
    "confirmNote": "Confermando colleghi questa identità locale dell’avversario al tuo account. Non condivide automaticamente partite future.",
    "claimError": "Impossibile collegare questa partita.",
    "successTitle": "PARTITA COLLEGATA",
    "successBody": "La partita è stata aggiunta al tuo Tennis Log privato dalla tua prospettiva.",
    "openMatch": "Apri la mia partita",
    "viewMatches": "Vedi partite"
  }
},
  ja: {
  "lockedNotice": "両プレーヤーが接続すると、共有されたマッチの事実はロックされます。あなたのプライベートなメモ、レーティング、個人データは編集できます。",
  "badge": "Connected Match",
  "status": {
    "title": "接続済み",
    "body": "この試合は {{name}} と接続されています。共有された事実はロックされ、プライベートなメモや評価はあなただけのものです。"
  },
  "sender": {
    "waiting": "招待の返答待ち",
    "waitingDetail": "{{name}} さんの確認待ちです。リンクは1回のみ使用でき、{{date}} に期限切れになります。",
    "replace": "リンクを再発行",
    "title": "この試合を連携する",
    "body": "対戦相手に試合を送信します。相手には共有される試合情報のみが表示され、自分のアカウントで確認して、自分専用の記録を受け取ります。",
    "send": "対戦相手に送る",
    "creating": "安全なリンクを作成中…",
    "ready": "招待の準備ができました",
    "readyDetail": "このリンクは1回だけ使用でき、{{date}} に期限が切れます。",
    "share": "共有",
    "copy": "リンクをコピー",
    "copied": "コピーしました",
    "newLink": "新しいリンク",
    "revoke": "無効にする",
    "revokedTitle": "招待を無効にしました",
    "revokedDetail": "以前のリンクは使用できません。同じ試合の招待をあらためて作成できます（試合を再入力する必要はありません）。",
    "reissue": "新しい招待を作成",
    "pilotNote": "パイロット版：シングルスのみ。評価、メモ、コンディション、スマートウォッチ/健康データは招待に含まれません。",
    "copiedToast": "招待リンクをコピーしました。",
    "revokedToast": "招待を無効にしました。",
    "errorCreate": "招待を作成できませんでした。",
    "errorRevoke": "招待を無効にできませんでした。",
    "errorShare": "招待リンクを共有できませんでした。",
    "errorCopy": "招待リンクをコピーできませんでした。"
  },
  "recipient": {
    "title": "試合を確認する",
    "subtitle": "1つの試合を、2人がそれぞれ非公開で記録します。",
    "loading": "安全な招待を読み込み中…",
    "unavailableTitle": "招待を利用できません",
    "missingToken": "招待リンクがない、または無効です。",
    "unavailable": "この招待は無効、またはすでに利用できません。",
    "invitedBy": "招待者",
    "date": "日付",
    "court": "コート",
    "surface": "サーフェス",
    "type": "種別",
    "scoreTitle": "あなたから見たスコア",
    "privacyTitle": "あなたの非公開データは公開されません",
    "privacyBody": "受け取るのは共有される試合情報のみです。評価、メモ、コンディション、スマートウォッチ/健康データはあなただけのものです。",
    "signInTitle": "確認するにはログイン",
    "signInBody": "ログインまたはアカウント作成の間、招待はこのブラウザに保存されます。",
    "signIn": "ログイン",
    "createAccount": "アカウント作成",
    "nameTitle": "表示名はどうしますか？",
    "nameBody": "Tennis Log での名前はあなたが決めます。送信者が変更することはできません。",
    "keepName": "現在の名前を使う",
    "useTheirName": "相手が入力した名前を使う",
    "differentName": "別の名前にする",
    "namePlaceholder": "Tennis Log の表示名",
    "confirm": "確認して自分の Tennis Log に追加",
    "confirming": "試合を連携中…",
    "confirmNote": "確認すると、この対戦相手の記録があなたのアカウントと結び付きます。今後の試合が自動共有されることはありません。",
    "claimError": "この試合を連携できませんでした。",
    "successTitle": "試合を連携しました",
    "successBody": "あなたの視点で、非公開の Tennis Log に試合が追加されました。",
    "openMatch": "自分の試合を開く",
    "viewMatches": "試合一覧を見る"
  }
},
};

